export const UNASSIGNED_SERVICE_AREA_OPTION_ID = 'unassigned';
